import { createRouter, createWebHistory } from 'vue-router'

import DispatchView from './pages/dispatch'
import StatView from './pages/stat'
import StatCarrierView from './pages/statCarrier'
import StatRateView from './pages/statRate'
import AppLogsView from './pages/applogs'
import CustomLogsView from './pages/customLogs'
import MathineLogsView from './pages/mathinelogs'
import TplSettingView from './pages/tplSetting'
import NormalSettingView from './pages/normalSetting'
import TaskView from './pages/task'
import CustomTaskView from './pages/customTask'
import PlusLimitView from './pages/pluslimit'

import * as Utils from './assets/utils'

const routes = [
  { path: '/', redirect: 'dispatch' },
  { path: '/dispatch', name: 'dispatch', component: DispatchView },
  { path: '/task', name: 'task', component: TaskView },
  { path: '/custom-task', name: 'custom-task', component: CustomTaskView },
  { path: '/stat-main', name: 'stat-main', component: StatView },
  { path: '/stat-carrier', name: 'stat-carrier', component: StatCarrierView },
  { path: '/stat-rate', name: 'stat-rate', component: StatRateView },
  { path: '/apps-logs', name: 'apps-logs', component: AppLogsView },
  { path: '/custom-logs', name: 'custom-logs', component: CustomLogsView },
  { path: '/mathines-logs', name: 'mathines-logs', component: MathineLogsView },
  { path: '/normal-setting', name: 'normal-setting', component: NormalSettingView },
  { path: '/tpl-setting', name: 'tpl-setting', component: TplSettingView },
  { path: '/pluslimit', name: 'pluslimit', component: PlusLimitView },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
})

router.beforeEach(async (to, from, next) => {
  console.log('to', to)
  if(to.name == 'pluslimit') {
    next()
  }else{
    const toMenuKey = ({
      'dispatch': 'dispatch',
      'task': 'hand_common_task',
      'custom-task': 'hand_custom_task',
      'stat-main': 'hand_stat_main',
      'stat-carrier': 'hand_stat_carrier',
      'stat-rate': 'hand_stat_rate',
      'apps-logs': 'hand_apps_logs',
      'custom-logs': 'hand_custom_logs',
      'mathines-logs': 'hand_mathines_logs',
      'normal-setting': 'hand_normal_setting',
      'tpl-setting': 'hand_tpl_setting',
    })[to?.name]
    const permisionFlag = await Utils.pluslimitChecker(toMenuKey);
    if(permisionFlag != 401){
      if(!permisionFlag && to.name !== 'pluslimit') {
        next({ path: `/pluslimit` });
      }else{
        next()
      }
    }
  }
  next()
});

export default router;